import axios from 'axios';

import { TDeleteAxiosResponse } from '@/common/types/response';

import { TKeyCountryIndicator } from '../types/keyCountryIndicator';

export default {
  create: function (request: TKeyCountryIndicator) {
    return axios.post(`/api/keyindicatorscountry`, request);
  },
  edit: function (id: number, request: TKeyCountryIndicator) {
    return axios.put(`/api/keyindicatorscountry/${id}`, request);
  },
  find: function (id: number) {
    return axios.get(`/api/keyindicatorscountry/${id}`);
  },
  delete: function (id: number): Promise<TDeleteAxiosResponse> {
    return axios.delete(`/api/keyindicatorscountry/${id}`);
  },
};
